module.exports = __webpack_public_path__ + "img/mobile_i6.3f539d0b.png";